// ignore-string-externalization
import * as Sentry from '@sentry/react';
import { getHash } from '../../../features/src/env';
import { beforeSend } from './beforeSend';

export function initSentry() {
  if (process.env.NODE_ENV !== 'production') return;

  Sentry.init({
    dsn: 'https://b77895087f0946d4b6baf7b3e1d9b999@o22381.ingest.sentry.io/4504498620268544',
    release: getHash(),
    sampleRate: 0.2,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.05,
    tracePropagationTargets: [/^https:\/\/artists\.spotify\.com/],
    allowUrls: [/artists\.spotify\.com/, /mrkt\.spotifycdn\.com/],
    denyUrls: [/otBannerSdk/, /otSDKStub/],
    ignoreErrors: [
      // Browser extensions
      /GM_getValue/,
      /GM_setValue/,
      // Native WebView bridges
      /window\.webkit\.messageHandlers/,
      // Crypto wallet extensions (MetaMask, etc.)
      /window\.ethereum/,
      // Sentry's own payload rejection
      /PAYLOAD_SIZE_LIMIT_EXCEEDED/,
      // Transport library throws on logged-out users (unhandled rejection bug)
      /^Error: logged out$/,
      // Browser autoplay policy — video.play() interrupted when browser pauses
      // background media to save power. Expected behavior, not a bug.
      /play\(\) request was interrupted/,
      // Script message handler unavailable — WebView bridge not present
      /Script message handler.*unavailable/,
    ],
    beforeSend,
  });
}
